import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
    isLoading: false,
    error: null,
    checkerpayment: [],
};


const slice = createSlice({
    name: 'checkerpayment',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET elementS
        getCheckerPayment(state, action) {
            state.isLoading = false;
            state.checkerpayment = action.payload;
        },

    },
});
export default slice.reducer;


export function getcheckerpayment() {
    return async () => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/api/admin/checkerpayments`);
            dispatch(slice.actions.getCheckerPayment(response?.data?.data));
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

